/* eslint-disable react-hooks/exhaustive-deps */
// @ts-ignore - CSS imports are handled by the project build tooling, not TS declarations.
import './sumary.scss';
import { Grid } from '@mui/material';
import React from 'react';
import TestSum from './components/TestSum';
// import { useAppDispatch } from 'app/hooks';
// import { useHistory } from 'react-router-dom';
// import { routers } from 'router/router';
// import { logout } from 'app/basicInformationSlice/basicInformationSlice';
// import counselorServices from 'services/counselorServices';
// import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';
// import Cookies from 'js-cookie';
// import { ConversationCard } from './ReviewPersonal';
// /import { authenticateSettings } from 'components/helper/appConfig';

const ReviewTest = () => {
  const [currentModuleId, setCurrentModuleId] = React.useState('4.1');
  // const dispatch = useAppDispatch();
  // const history = useHistory();  
  // let studentId = getUserId();
  // let token = getAccessToken();
  // const [listCounselorConnection, setListCounselorConnection] = React.useState<any[]>([]);

  // const handleLogout = () => {
  //   dispatch(logout());
  //   removeAccessToken();
  //   removeUserId();
  //   history.push(routers.login.path);
  // };

  // const getData = () => {
  //   studentId = getUserId();
  //   token = getAccessToken();
  //   if (token && studentId) {
  //     counselorServices.getCounselors(studentId).then((res: any[]) => {
  //       setListCounselorConnection(res ?? []);
  //     });
  //   }
  //   else {
  //     handleLogout();
  //   }    
  // };

  // React.useEffect(() => {
  //   getData();
  // }, []);

  console.log('currentModuleId: ', currentModuleId);
  return (
    <Grid container sx={{ width: '100%' }}>
      <Grid item xs={12} md={8}>
        <TestSum setCurrentModuleId={setCurrentModuleId} />
      </Grid>
      {/* <Grid item xs={12} md={4} sx={{ marginTop: { md: '48px' } }}>
        {listCounselorConnection.map((item, index) => (
          <ConversationCard conversationItem={item} currentModuleId={currentModuleId} key={index} />
        ))}
      </Grid> */}
    </Grid>
  );
};

export default ReviewTest;
